import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalSuccessMessage";
import Input from "../../../components/Input";
import Tooltip from "../../../components/Tooltip";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";

import { LegendContainer, Legend, Label, Fieldset, LabelInput, CheckContainer, SelectContainer, Select, ButtonContainer, TranparentButton } from "./styles";

import routes from "../../../routes/configuration.routes";
import Main from "../../../components/Main/index";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Assets
import doc from "../../../assets/icons/complete.svg";
import feedback from "../../../assets/icons/sms.svg";
import hint from "../../../assets/icons/hint.svg";
import api from "../../../service/api";

const General = () => {
    const [isInputDisabled, setIsInputDisabled] = useState(true);
    const [configData, setConfigData] = useState({
        pendente_whatsapp: false,
        pendente_sms: false,
        pendente_email: false,
        pendente_delay: 0,
        aprovado_whatsapp: false,
        aprovado_sms: false,
        aprovado_email: false,
        recusado_whatsapp: false,
        recusado_sms: false,
        recusado_email: false,
        multa: 0,
        juros: 0,
        instructions: ""
    });

    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    useEffect(() => {
        if(login.user.groups.cm6a5 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    useEffect(() => {
        const getConfigAtApi = async () => {
            const {data} = await api.get(`/adm/ownerbranch/list?id=${login.user.branchsId}&configuration=true`);
            
            setConfigData(data.Configurations);
        }

        getConfigAtApi();
    }, []);

    const formValidationWithYup = Yup.object().shape({
        feedbackPendentSellInterval: Yup.number(),
        instructions: Yup.string(),
        mulct: Yup.string(),
        interest: Yup.string(),
        pendentSellWhatsapp: Yup.boolean(),
        pendentSellSms: Yup.boolean(),
        pendentSellEmail: Yup.boolean(),
        approvedSellWhatsapp: Yup.boolean(),
        approvedSellSms: Yup.boolean(),
        approvedSellEmail: Yup.boolean(),
        failedSellWhatsapp: Yup.boolean(),
        failedSellSms: Yup.boolean(),
        failedSellEmail: Yup.boolean(),
    })
    
    return(
        <Main>
            <Header title="Configuração" subTitle="Altere as configurações gerais do sistema caso seja nescessário" subTitleWidth={271}/>
            <NavTabs tabs={routes}/>
            <Modal text="Alterações realizadas com Sucesso"/>

            <Formik
                initialValues={{
                    feedbackPendentSellInterval: 2,
                    instructions: "",
                    mulct: 0,
                    interest: 0,
                    pendentSellWhatsapp: false,
                    // pendentSellSms: false,
                    pendentSellEmail: false,
                    approvedSellWhatsapp: false,
                    // approvedSellSms: false,
                    approvedSellEmail: false,
                    failedSellWhatsapp: false,
                    // failedSellSms: false,
                    failedSellEmail: false,
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    try{
                        const {data} = await api.put(`configuration/update?id=${login.user.branchsId}`, {
                            "taxpayerIdBranch": login.user.branchs.taxpayerIdBranch,
                            "pendente_whatsapp": values.pendentSellWhatsapp ? 1 : 0,
                            "pendente_sms": 0, //values.pendentSellSms ? 1 :
                            "pendente_email": values.pendentSellEmail ? 1 : 0,
                            "pendente_delay": values.feedbackPendentSellInterval,
                            "aprovado_whatsapp": values.approvedSellWhatsapp ? 1 : 0,
                            "aprovado_sms": 0, //values.approvedSellSms ? 1 : 
                            "aprovado_email": values.approvedSellEmail ? 1 : 0,
                            "aprovado_delay": 0,
                            "recusado_whatsapp": values.failedSellWhatsapp ? 1 : 0,
                            "recusado_sms": 0, //values.failedSellSms ? 1 : 
                            "recusado_email": values.failedSellEmail ? 1 : 0,
                            "recusado_delay": 0,
                            "multa": values.mulct,
                            "juros": values.interest,
                            "instructions": values.instructions
                        });
                        
                        setErrorOnReturnApi(true);
                        openModal("exampleModal");
                    } catch (err) {
                        setErrorOnReturnApi(false);
                    }
                }}
            >
                {({initialValues, errors, handleChange, handleSubmit}) => {
                    initialValues.mulct = configData.multa;
                    initialValues.interest = configData.juros;
                    initialValues.instructions = configData.instructions; 
                    initialValues.approvedSellEmail = configData.aprovado_email;
                    // initialValues.approvedSellSms = configData.aprovado_sms;
                    initialValues.approvedSellWhatsapp = configData.aprovado_whatsapp;
                    initialValues.failedSellEmail = configData.recusado_email;
                    // initialValues.failedSellSms = configData.recusado_sms;
                    initialValues.failedSellWhatsapp = configData.recusado_whatsapp;
                    initialValues.pendentSellEmail = configData.pendente_email;
                    // initialValues.pendentSellSms = configData.pendente_sms;
                    initialValues.pendentSellWhatsapp = configData.pendente_whatsapp;
                    initialValues.feedbackPendentSellInterval = configData.pendente_delay

                    return(
                        <Form>
                            <>
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                        <Fieldset>
                                            <LegendContainer>
                                                <img src={feedback}/>
                                                <Legend>Feedback</Legend>
                                            </LegendContainer>

                                            <Label>Venda pendente</Label>
                                            <div className="d-flex">
                                                <CheckContainer>
                                                    <Field id="pendentSellWhatsapp" name="pendentSellWhatsapp" type="checkbox" style={{marginRight: 3}}/>
                                                    <label htmlFor="whatsappCheck1">
                                                        Whatsapp
                                                    </label>
                                                </CheckContainer>
                                                <CheckContainer>
                                                    <input id="pendentSellEmail" name="pendentSellEmail" type="checkbox" style={{marginRight: 3}}/>
                                                    <label htmlFor="emailCheck1">
                                                        Email
                                                    </label>
                                                </CheckContainer>
                                            </div>
                                            
                                            <SelectContainer>
                                                <Field id="feedbackPendentSellInterval" name="feedbackPendentSellInterval" as={Select}>
                                                    <option value={2}>2 dias antes</option>
                                                    <option value={5}>5 dias antes</option>
                                                </Field>
                                                <div>
                                                    <img 
                                                        src={hint}
                                                        style={{marginLeft: 3}}
                                                        onMouseEnter={() => setIsTooltipVisible(true)}
                                                        onMouseLeave={() => setIsTooltipVisible(false)}
                                                    />
                                                    {isTooltipVisible ? <Tooltip text="Dias de antecedência"/> : null}
                                                </div>
                                            </SelectContainer>

                                            <Label>Venda aprovada</Label>
                                            <div className="d-flex">
                                                <CheckContainer>
                                                    <Field id="approvedSellWhatsapp" name="approvedSellWhatsapp" type="checkbox" style={{marginRight: 3}} />
                                                    <label htmlFor="whatsappCheck2">
                                                        Whatsapp
                                                    </label>
                                                </CheckContainer>
                                                <CheckContainer>
                                                    <Field id="approvedSellEmail" name="approvedSellEmail" type="checkbox" style={{marginRight: 3}} />
                                                    <label htmlFor="emailCheck2">
                                                        Email
                                                    </label>
                                                </CheckContainer>
                                            </div>
                                            <Label>Venda recusada</Label>
                                            <div className="d-flex">
                                                <CheckContainer>
                                                    <Field id="failedSellWhatsapp" name="failedSellWhatsapp" type="checkbox" style={{marginRight: 3}}  />
                                                    <label htmlFor="whatsappCheck3">
                                                        Whatsapp
                                                    </label>
                                                </CheckContainer>
                                                <CheckContainer>
                                                    <Field id="failedSellEmail" name="failedSellEmail" type="checkbox" style={{marginRight: 3}} />
                                                    <label htmlFor="emailCheck3">
                                                        Email
                                                    </label>
                                                </CheckContainer>
                                            </div>
                                        </Fieldset>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <fieldset>
                                            <LegendContainer>
                                                <img src={doc}/>
                                                <Legend>Boleto Completo</Legend>
                                            </LegendContainer>
                                            <div className="d-flex">
                                                <div className="col-4 pl-0">
                                                    <LabelInput>
                                                        Multa%
                                                    </LabelInput>
                                                    <Field id="mulct" name="mulct" className="inputCustom" disabled={isInputDisabled} as={Input}/>
                                                </div>

                                                <div className="col-4">
                                                    <LabelInput>
                                                        Juros%
                                                    </LabelInput>
                                                    <Field id="interest" name="interest" className="inputCustom" disabled={isInputDisabled} as={Input}/>
                                                </div>
                                                
                                                <div className="col-4 d-flex align-items-center">
                                                    <TranparentButton onClick={() => setIsInputDisabled(false)}>Alterar valores</TranparentButton>
                                                </div>
                                            </div>

                                            <div>
                                                <LabelInput>Instruções Corpo do Boleto (Padrão)</LabelInput>
                                                <Field id="instructions" name="instructions" className="inputCustom" as={Input}/>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>

                                {
                                    errorOnReturnApi ? 
                                        <ErrorMessage>
                                            Falha ao atualizar informações
                                        </ErrorMessage> : null
                                }
                                
                                <ButtonContainer>
                                    <Button type="submit">Salvar Alterações</Button>
                                </ButtonContainer>
                            </>
                        </Form>
                    )
                }}
            </Formik>
        </Main>
    )
}

export default General;